var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{on:{"enter":_vm.onEnter,"leave":_vm.onLeave,"before-leave":_vm.onBeforeLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"transitionContainer",staticClass:"transitionContainer",style:({ transitionDuration: _vm.duration + 'ms' })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }